import { render } from "./KYCReport.vue?vue&type=template&id=1df95b58"
import script from "./KYCReport.vue?vue&type=script&lang=js"
export * from "./KYCReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__